module.exports = __webpack_public_path__ + "static/media/open_api_en.72486c83.md";